const textStoragesDefinition = {
  hungarian: {
    id: "hu",
    menuOptions: {
      "about-me": "Rólam",
      services: "Szolgáltatások",
      gallery: "Galéria",
      prices: "Árak",
      connect: "Kapcsolat",
      faq: "GYIK",
    },
    footerInfo: {
      phoneNumberLabel: "Tel",
      phoneNumber: "+36 30 265 0550",
      emailLabel: "E-mail",
      email: "vaszily.eszter.foto@gmail.com",
      facebookLink: "https://www.facebook.com/profile.php?id=61581878450953#",
      instagramLink: "https://www.instagram.com/vaszily.eszter.foto/",
      linkedinLink: "https://www.linkedin.com/in/eszter-vaszily-253773387",
    },
    languageSelectorDisplayText: "HU",
    pages: {
      home: {
        aboutMeSection: {
          title: "Rólam",
          text: "Mindig is fényképeztem, csak eleinte még nem tudtam, hogy ez munka is lehet. Az emberekkel könnyen szót értek, talán mert nem próbálok belőlük mást csinálni, mint akik valójában. A fotózás nálam nem ünnepélyes esemény — inkább egy jól sikerült beszélgetés, aminek a végén marad néhány kép is.",
          button: "Bővebben",
        },
        servicesSection: {
          title: "Szolgáltatások",
          text: "Megörökítem azokat a pillanatokat, amik igazán számítanak. Legyen szó portré- vagy családi fotózásról, vagy akár a négylábú kedvencekről – nálam mindenki főszereplő lehet.",
          cards: [
            {
              title: "Kutya- és állatfotózás",
              buttonText: "Bővebben",
            },
            {
              title: "Portréfotózás",
              buttonText: "Bővebben",
            },
            {
              title: "Családi fotózás",
              buttonText: "Bővebben",
            },
          ],
        },
        gallerySection: {
          title: "Galéria",
          text: "Itt megnézheted, milyen hangulatú képek születnek a fotózásokon. Valós pillanatok, természetes fények, emberi kapcsolatok – minden sorozat más, mert minden történet más.",
          buttonText: "További képek",
        },
        pricesSection: {
          title: "Árak",
          text: "Az itt található csomagok segítenek eligazodni, de minden fotózás egyedi – ahogy te is. Ha valami mást szeretnél, írj bátran, szívesen alakítom személyre.",
          cards: [
            {
              title: "Vaku Csomag",
              description:
                "Tökéletes, gyors, mégis profi fotós élményhez – pl. egyéni portréhoz, kisgyermek fotózáshoz.",
              listItems: [
                "1 óra (Pont elég arra, hogy mindenki ellazuljon, és az együttlétből valami valódi szülessen.)",
                "20 retusált kép",
                "online letöltési lehetőség nagy felbontásban",
                "1 helyszín (stúdió, szabadtér vagy saját otthon, amennyiben az otthon alkalmas erre)",
                "ha bérelt stúdióban készülnek a képek, akkor + a stúdió bérleti díja",
              ],
              price: "49 000 Ft",
              buttonText: "Érdekel",
            },
            {
              title: "Fókusz Csomag",
              description:
                "Ideális családi, kismama vagy páros fotózásra – van idő, tér, játék és természetes pillanatok.",
              listItems: [
                "2 óra (Kicsit több idő, több nevetés, több mozdulat. Ha szeretsz ráérni, ez a te tereped.)",
                "30 retusált kép",
                "online letöltési lehetőség nagy felbontásban",
                "1 helyszín (saját stúdió, szabadtér vagy saját otthon, amennyiben az otthon alkalmas erre)",
                "ha bérelt stúdióban készülnek a képek, akkor + a stúdió bérleti díja",
              ],
              price: "65 000 Ft",
              buttonText: "Érdekel",
            },
            {
              title: "Nagylátószög Csomag",
              description:
                "A legszebb pillanatok teljes nyugalomban, sok képpel és emlékkel – ideális újszülött vagy családi fotózásra.",
              listItems: [
                "3 óra (Ebből egy nagyon kerek sztori lesz, amit sokáig emlegetni fogsz.)",
                "50 retusált kép",
                "online letöltési lehetőség nagy felbontásban",
                "1 helyszín (saját stúdió, szabadtér vagy saját otthon, amennyiben az otthon alkalmas erre)",
                "ha bérelt stúdióban készülnek a képek, akkor + a stúdió bérleti díja",
              ],
              price: "80 000 Ft",
              buttonText: "Érdekel",
            },
          ],
        },
        testimonialsSection: {
          title: "Vélemények",
          testimonials: [
            {
              name: "Kiss Kaszás Detti",
              text: "Imádom Eszterrel a fotózást, mindig tökéletes képeket kapunk. Tervem az volt, hogy ne beállított, mű képek szülessenek és ezt tökéletesen kivitelezte, elkapta a szép pillanatokat! Várom már a következő fotózásokat, mert biztosan sokszor fogom keresni őt ezzel kapcsolatban!",
            },
            {
              name: "Ildikó",
              text: "A fotózás fesztelenül és vidáman zajlott,  nagyon jól éreztem magam. Kicsit aggodalmasan vágtam bele, de Eszter a fotókon olyan arcomat hozta elő, amiről azt hittem, hogy már rég elveszett. Minden szempontból csak ajánlani tudom a stúdiót!",
            },
          ],
        },
        connectSection: {
          title: "Kapcsolat",
          text: "Ha tetszenek a képeim, és úgy érzed, szívesen dolgoznál velem, ne habozz – foglalj időpontot! Írj pár sort az elképzeléseidről, és hamarosan visszajelzek. Együtt kitaláljuk, hogyan lesz a fotózás gördülékeny, személyre szabott és emlékezetes.",
          nameLabel: "Név",
          phoneNumberLabel: "Telefonszám",
          emailLabel: "E-mail",
          serviceLabel: "Szolgáltatás",
          messageLabel: "Üzenet",
          serviceOptions: [
            {
              value: "allat",
              label: "Kutya-és állat fotózás",
            },
            { value: "portre", label: "Portré" },
            { value: "csaladi", label: "Családi fotózás" },
          ],
          invalidPhoneNumberTitle: "Példa: +36 30 123 4567",
          formSubmitError:
            "Hiba történt a küldés során, kérjem próbálja újra később.",
        },
        faqSection: {
          title: "GYIK",
          faqs: [
            {
              question: "Hogyan zajlik a fotózás?",
              answer:
                "A lényeg az, hogy a fotózás fesztelen és kellemes hangulatú legyen. Ezért szánjunk néhány percet arra, hogy feloldódjon mindenki, és picit megismerjük egymást.\n\nKitaláljuk a koncepciót, feltérképezzük, hogy kinek milyen igényei vannak és aztán belevágunk.\n\nSzívesen fogadok inspirációs képeket, ha úgy jobban tudjátok érzékeltetni, hogy mire gondoltatok, de azt is lehet, hogy együtt kitaláljuk.\n\nHa bizonytalankodsz, akkor előzetesen telefonon is egyeztethetünk és akkor senkit nem ér meglepetés",
            },
            {
              question: "Mennyi ideig tart egy fotózás?",
              answer:
                "2 óra biztosan kell ahhoz, hogy mindenki elégedett legyen a végeredménnyel, és ne tűnjön rohanósnak az alkalom. Pláne, ha több szett ruha kerül elő, akkor biztosan kell rá időt szánni. Ha belecsúszunk a 3-ba, az sem baj. A lényeg, hogy kerek legyen a történet.",
            },
            {
              question: "Hány napos babával készülnek az újszülött fotók?",
              answer:
                "Az újszülött fotókat általában nagyon apró babákkal szokták készíteni, de ettől még ez nem szentírás. Lehet több hetes babával is vagy akár több hónapossal is. Ez is attól függ, hogy kinek milyen elképzelése van vagy éppen mikor érzi magát elég komfortosan ahhoz, hogy bevállalja a fotózást.",
            },
            {
              question: "Hol történik a fotózás? Van stúdió?",
              answer:
                "A fotózás alapértelmezésben a stúdiómban zajlik, de ha a lakásotok alkalmas arra, hogy ott hozzuk össze, akkor akár házhoz is megyek.\n\nHa a szabadban szeretnétek dolgozni, akkor egyeztetjük a helyszínt, ahol találkozunk és ott ejtjük meg a fotózást. Alkalmazkodom az igényekhez, minden megbeszélés kérdése. Ha egy kiválasztott stúdióban szeretnétek a fotózást, arra is van lehetőség természetesen, de akkor a stúdió bérleti díja plusz költség a csomag díján felül.",
            },
            {
              question: "Hány képet kapunk? Milyen formátumban?",
              answer:
                "Három csomag közül választhattok. A csomagok részletes leírását a szolgáltatások menüpont alatt találjátok.\n\nAz utómunkázott képek jpg formátumban kerülnek átadásra, online galériából letölthető verzióban.",
            },
            {
              question: "Hogyan történik a fizetés?",
              answer:
                "Lehet kártyával és lehet készpénzben. Ahogy nektek a legkényelmesebb.",
            },
          ],
        },
      },
      services: {
        sections: [
          {
            title: "Kutya-és állatfotózás",
            paragraphs: [
              "A kutya az örök szerelem. Megunhatatlan fényképezni őket még akkor is, ha sokszor kihívásokkal teli a folyamat, aminek az eredménye végül csodálattal tölt el. Előfordul, hogy a földön hasalok vagy lehetetlen pózokban görnyedek egy fa mögött és bár a stúdióban tisztább marad a nadrágom, azért vitathatatlanul vicces a szabadtéri fotózás.",
              "A kutyák nem kérik, hogy szépek legyenek a képen. Ők csak csinálják, ami nekik tetszik. Én meg próbálom utolérni őket a fényképezővel, hogy megörökítsem azt, amiért nekünk tetszenek.",
            ],
          },
          {
            title: "Portréfotózás",
            paragraphs: [
              "Az emberi arc sosem ismétli önmagát, ezért portrét készíteni mindig felelősség. Aki leül a gépem elé, valamit odaad magából, én pedig igyekszem a legnagyobb felelősséggel visszaadni. Addig dolgozom, amíg meg nem születik az a kép, amelyben saját magát is felismeri. Néha csak lassan, máskor azonnal, néha nevetve, néha makacs hallgatással.",
              "Ezért az egyik kedvenc műfajom a portré fotózás. Mert kibontani a mindennapok hajtása mögötti személyiséget, igazi művészet és végtelen sikerélmény. Olyankor a fotón az is felfedi valódi természetét, amit szavakkal ritkán tudunk kifejezni.",
            ],
          },
          {
            title: "Családi fotózás",
            paragraphs: [
              "Minden gyerekben van valami, amit nagyon lehet szeretni, és pár perc alatt kiderül, hogy a fényképezés mókás elfoglaltság. Persze, van úgy, hogy éppen nincs kedve hozzám. Ez teljesen rendben van. Én is voltam gyerek, sokszor nekem sem volt kedvem semmihez.",
              "Az a taktikám, hogy ha a fotózás alatt inkább bújócskázik az asztal alatt, vagy a testvére haját húzza - csak várok türelmesen, mosolyogva. Előbb-utóbb mindenki meggondolja magát, és onnantól működik a dolog.",
            ],
          },
        ],
        buttonTextConnect: "Érdekel",
        buttonTextGallery: "Galéria",
      },
      aboutMe: {
        title: "Rólam",
        paragraphs: [
          "Számomra is rejtély hogy hogy alakult ki, de az utóbbi 25 évben - némi kihagyással ugyan - de folyamatosan ott volt a kezemben a fényképezőgép. Komoly elhatározás vagy hirtelen fellángolás helyett természetes folyamat eredménye, hogy érdeklődésből hobbi, majd hivatás lett. A gesztusokban megbújó személyiség, egy családi pillanat észrevétlen dinamikája, egy kíváncsi kutya figyelő szeme - csak jól kell fókuszálni, és csodás történetek bontakoznak ki előttem.",
          "A stúdió zárt biztonságában és a szabadtéri helyszíneken is ugyanaz a célom: megteremteni a légkört, amiben a jelenlét őszinte és felszabadult. Ehhez nem díszlet kell, hanem ráhangolódás – ebben hiszek, és ebből építkezem, mikor valakivel együtt dolgozom. A bizalmas kapcsolódás könnyen kialakul nálam, mert nem színpadot kínálok, hanem figyelmet. A nevetés, a kötetlen beszélgetés éppúgy része a közös munkának, mint a fények és beállítások. Így lesz a fotózásra szánt időből egyszeri és megismételhetetlen élmény, pont olyan különleges, mint az elkészült képek.",
        ],
        buttonText: "Tovább a galériára",
      },
      gallery: {
        title: "Galéria",
        buttonText: "Érdekel",
      },
    },
  },
} as const

export const homeSubLinkNames = new Set(["prices", "connect", "faq"])

export type AvailableLanguageKey = keyof typeof textStoragesDefinition
export type TextStorage = (typeof textStoragesDefinition)[AvailableLanguageKey]
export const textStorages = textStoragesDefinition

export const mapLanguageKeyToLanguageSelectorDisplayText = (
  languageKey: AvailableLanguageKey,
) => {
  return textStorages[languageKey].languageSelectorDisplayText
}

export const mapServiceKeyToServiceLabel = (serviceKey: string) => {
  return textStorages.hungarian.pages.home.connectSection.serviceOptions.find(
    (option) => option.value === serviceKey,
  )?.label
}
